// Runtime API configuration - can be overridden by setting window.HMI_API_BASE
const API_BASE = window.HMI_API_BASE || process.env.REACT_APP_API_URL || 'https://api.heresmyinfo.com/api'

function getAuthToken() {
  const token = window.localStorage.getItem('HMI_AUTH_TOKEN')
  console.log('API: Getting auth token:', token ? 'Token exists' : 'No token')
  return token
}

function setAuthToken(token) {
  console.log('API: Setting auth token:', token ? 'Token exists' : 'No token')
  if (token) {
    window.localStorage.setItem('HMI_AUTH_TOKEN', token)
  } else {
    window.localStorage.removeItem('HMI_AUTH_TOKEN')
  }
}

function authHeaders() {
  const token = getAuthToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export async function login(email, password) {
  console.log('API: Login attempt for:', email)
  const res = await fetch(`${API_BASE}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password })
  })
  if (!res.ok) throw new Error('Login failed')
  const data = await res.json()
  console.log('API: Login response:', data)
  if (data.success && data.data && data.data.token) {
    console.log('API: Setting auth token:', data.data.token ? 'Token exists' : 'No token')
    setAuthToken(data.data.token)
    // Start token refresh timer
    startTokenRefreshTimer()
  } else {
    console.log('API: No token in response')
  }
  return data
}

export async function logout() {
  setAuthToken(null)
  stopTokenRefreshTimer()
}

export async function getProfile() {
  const headers = authHeaders()
  console.log('API: getProfile headers:', headers)
  const res = await fetch(`${API_BASE}/users/profile?t=${Date.now()}`, {
    headers
  })
  console.log('API: getProfile response status:', res.status)
  if (!res.ok) {
    const errorText = await res.text()
    console.log('API: getProfile error response:', errorText)
    throw new Error('Unauthorized')
  }
  return res.json()
}

export async function validateToken() {
  const token = getAuthToken()
  if (!token) return false

  try {
    const res = await fetch(`${API_BASE}/users/profile`, {
      headers: { ...authHeaders() }
    })
    return res.ok
  } catch (error) {
    return false
  }
}

export const tokenStorage = { getAuthToken, setAuthToken, validateToken }
export { authHeaders }

// Auto-refresh token functionality
let tokenRefreshTimer = null

export const startTokenRefreshTimer = () => {
  // Clear any existing timer
  if (tokenRefreshTimer) {
    clearTimeout(tokenRefreshTimer)
  }

  // Set timer to refresh token every 23 hours (assuming 24-hour token expiry)
  tokenRefreshTimer = setTimeout(async () => {
    try {
      // Try to validate the current token
      const isValid = await validateToken()
      if (isValid) {
        // Token is still valid, set up next refresh
        startTokenRefreshTimer()
      } else {
        // Token expired, clear it
        setAuthToken(null)
      }
    } catch (error) {
      console.error('Token refresh failed:', error)
      setAuthToken(null)
    }
  }, 23 * 60 * 60 * 1000) // 23 hours in milliseconds
}

export const stopTokenRefreshTimer = () => {
  if (tokenRefreshTimer) {
    clearTimeout(tokenRefreshTimer)
    tokenRefreshTimer = null
  }
}

// Invitations API
export async function sendInvitation({ toUserId, email, phone, subject, message }) {
  const body = { toUserId, email, phone, subject, message }
  const res = await fetch(`${API_BASE}/invitations`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeaders() },
    body: JSON.stringify(body)
  })
  if (!res.ok) throw new Error('Failed to send invitation')
  return res.json()
}

export async function getSentInvitations() {
  const res = await fetch(`${API_BASE}/invitations/sent`, {
    headers: { ...authHeaders() }
  })
  if (!res.ok) throw new Error('Failed to load sent invitations')
  return res.json()
}
